<div class="legend" *ngIf="data() !== undefined && data().options !== undefined">
  <div class="legend-row" *ngFor="let d of data().options.series[0].data">
    <span class="legend-dot" [ngStyle]="{backgroundColor: d.color}"></span>
    <span class="legend-value">{{d.y}}%</span>
    <span class="legend-name">
      {{d.name}}
      <a *ngIf="d.info" [attr.data-tooltip]="d.info" class="info-tip">
        <i class="bi bi-info-circle"></i>
      </a>
    </span>
  </div>
</div>